import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _9mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"9mp"} ref={ref}/>
});

_9mpIcon.displayName = "_9mpIcon";
